import { Component, OnInit, signal } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import * as BUTTON_CONFIG from '../../../../../constants/button/index';
import { BREAK_TYPE_ENUM } from '../../../../../constants/lookup/common/break-type.enum';
import { TimeSheetBreakType } from '../../../../../constants/lookup/timesheet/break-type.enum';
import { TimesheetType } from '../../../../../constants/lookup/timesheet/timesheet-type.enum';
import { API_METHOD_CONSTANTS } from '../../../../../constants/ngrx-store/core';
import { SCHEDULE_METHOD_CONSTANT } from '../../../../../constants/ngrx-store/schedule';
import { ScheduleStoreService } from '../../../../../state/modules/schedule/schedule-store.service';
import { noRecordFound } from './shift-break-actual-details.constant';

@Component({
  standalone: false,
  selector: 'kt-shift-break-actual-details',
  templateUrl: './shift-break-actual-details.component.html',
  styleUrls: ['./shift-break-actual-details.component.scss']
})
export class ShiftBreakActualDetailsComponent implements OnInit {
  noRecordFound = noRecordFound ;
  breaks = [];
  breakTypeEnum = BREAK_TYPE_ENUM;
  buttonConfig = BUTTON_CONFIG;
  loading = signal(false);
  timesheetId = 0;
  shiftId = 0;
  type = null;
  constructor(public activeModal: NgbActiveModal, private scheduleStoreService: ScheduleStoreService) {

  }
  ngOnInit() {
    this.dispatchGetBreak();
  }


  setBreak(data) {
    this.loading.set(false);
    if (data.success) {
      const breaks = data.data.data.shift_breaks;
      (breaks || []).forEach(breakDetails => {
        if (breakDetails && breakDetails.actual_break && breakDetails.actual_break.length) {
          breakDetails.actual_break.forEach(breakD => {
            if (this.type && this.type.toUpperCase() === breakD.timesheet_log_name.toUpperCase()) {
              this.breaks.push(breakD);
            }

          });
        }
      });
    }
  }
  dispatchGetBreak() {
    this.loading.set(true);
    this.scheduleStoreService.dispatchScheduleCommon({
      module: SCHEDULE_METHOD_CONSTANT.SHIFT_BREAK,
      method: API_METHOD_CONSTANTS.GET_ALL_WITH_PARAMETERS,
      callback: this.setBreak.bind(this),
      data : {
        timesheet_id: this.timesheetId || 0,
        shift_id: this.shiftId || 0,
        type: TimesheetType.TIMESHEET,
        break_type: TimeSheetBreakType.Both,
      },
    });
  }
}
